module.exports = __webpack_public_path__ + "img/gq.d16da126.svg";